<template>
    <v-app id="inspire">
            <v-navigation-drawer v-model="drawer" app fixed color="#fff" style="max-width:250;">
            <v-list-item tow-line color="#000">
                <v-list-item-avatar rounded size="40" color="#fff">
                    <v-img src="/images/avatar.webp"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-subtitle style="color:#000;">
                        <span v-if="name != null">Hello! {{name}}</span>
                        <span v-else>Hello! Welcome</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle style="color:#000;">
                        <span v-if="email != null">{{email}}</span>
                        <span v-else>Guest</span>
                    </v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>
            <v-list nav dense>
                <v-subheader>
                    Users & Company Profile
                </v-subheader>

                <v-list-item to="/myaccount">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-contacts-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>My Account</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/more">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-home-import-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>More</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>
               <v-subheader>
                    Other Service
                </v-subheader>
                <v-list-item to="/group-order">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-account-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Group Order</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

             <v-list-item to="/restaurant-signup">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-card-account-details</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Vendor Registration</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/track-order">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-shopping-search</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Track Order</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-subheader>Contact Info </v-subheader>

                <v-list-item class="contactinfo">
                    <v-list-item-content>
                        <v-list-item-title tag="a" href="tel:+91 88099-52644">
                            <v-icon>mdi-phone-classic</v-icon> +91 88099-52644
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="https://api.whatsapp.com/send?phone=918809952644" target="_blank">
                            <v-icon>mdi-whatsapp</v-icon> +91 88099-52644
                        </v-list-item-title>
                        <!-- <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                            <v-icon>mdi-email-outline</v-icon> support@trainway.co.in
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="https://www.facebook.com/profile.php?id=61550849225493/" target="_blank">
                            <v-icon>mdi-facebook</v-icon> Follow us on Facebook
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="https://in.pinterest.com/trainway/" target="_blank">
                            <v-icon>mdi-pinterest</v-icon> Follow us on Twitter
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="https://www.instagram.com/trainwaay/" target="_blank">
                            <v-icon>mdi-instagram</v-icon> Follow us on Instagram
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="https://www.youtube.com/@trainwaay/
    " target="_blank">
                            <v-icon>mdi-youtube</v-icon> Follow us on YouTube
                        </v-list-item-title> -->

                    </v-list-item-content>
                </v-list-item>

                <!-- <v-subheader>
                 Download the App
                </v-subheader>

                <v-list-item>
                    <v-list-item-content class="contactinfo">
                        <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                        <v-img src="/images/gplay.webp"></v-img>
                        </v-list-item-title>
                        <v-list-item-title tag="a" href="mailto:support@trainway.co.in" target="_blank">
                         <v-img src="/images/appstore.webp"></v-img>
                        </v-list-item-title>
                </v-list-item-content>
                </v-list-item> -->

            </v-list>
        </v-navigation-drawer>

        <v-app-bar app elevation="0" color="#05445E" dark fixed top>
        <v-container class="fill-height d-flex d-sm-none align-center px-0">
                <a @click="$router.go(-1)"><v-icon color="#ffffff">mdi-chevron-left</v-icon></a>
                <p class="mb-0" style="line-height: 17px;color:#ffffff;">Back</p>
            </v-container>

            <v-container class="fill-height d-none d-sm-flex align-center">
                <router-link to="/"> <v-img src="/images/trainway.webp" max-width="130"></v-img>  </router-link>
                <v-spacer></v-spacer>
                <v-btn to="/" elevation="0" color="#ffffff" text>HOME</v-btn>
                <v-btn to="/check-pnr-status" elevation="0" color="#ffffff" text>PNR STATUS</v-btn>
                <v-btn to="/train-running-status" elevation="0" color="#ffffff" text>RUNNING STATUS</v-btn>
                <v-btn to="/seat-availability" elevation="0" color="#ffffff" text>SEAT AVAILABILITY</v-btn>
                <v-btn to="/train-between-stations" elevation="0" color="#ffffff" text>TRAIN BETWEEN STATION</v-btn>
                <v-btn to="/login" elevation="0" color="#ffffff" text>TRACK ORDER</v-btn>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-cellphone-basic</v-icon>  </v-btn>
        <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 30px">
        <v-icon>mdi-whatsapp</v-icon> </v-btn>
        </v-container>
    </v-app-bar>
    <v-main>
        <v-sheet color="#05445E" height="80" class="px-3 py-4" style="margin-bottom:-50px;">

        </v-sheet>
        <v-container>
            <v-row>
                <v-col cols="12" md="8">

                    <v-card elevation="0">
                        <v-card-text>
                            <v-text-field outlined label="Enter Order ID " v-model="orderid"></v-text-field>
                            <v-btn block color="#05445E" x-large style="color:#fff" @click="trackorder">Track Order</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </v-main>
<!-- footer mobile menu -->
<v-bottom-navigation fixed temporary class="d-flex d-sm-none" id="fixedbottom">
    <v-btn to="/" class="mobileFooterMenu">
        <span class="black--text">Menu</span>
        <v-icon class="black--text">mdi-menu</v-icon>
      </v-btn>
      <v-btn  class="mobileFooterMenu" text tag="a" to="/check-pnr-status">
        <span class="black--text">PNR Status</span>
        <v-icon class="black--text">mdi-state-machine</v-icon>
      </v-btn>
      <v-btn class="mobileFooterMenu" text tag="a" to="/train-running-status">
        <span class="black--text">Spot Train</span>
        <v-icon class="black--text">mdi-train</v-icon>
      </v-btn>
      <v-btn class="mobileFooterMenu"  text tag="a" href="/train-ticket" target="_blank">
        <span class="black--text">Train Ticket</span>
        <v-icon class="black--text">mdi-ticket-account</v-icon>
      </v-btn>
      <v-btn to="/" class="mobileFooterMenu">
        <span class="black--text">Home</span>
        <v-icon class="black--text">mdi-home</v-icon>
      </v-btn>
      </v-bottom-navigation>
    <!-- footer mobile menu -->
    <Footer></Footer>
    <v-snackbar v-model="snackbar">
        {{ snackbartext }}
        <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
                Close
            </v-btn>
        </template>
    </v-snackbar>

</v-app>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle,
            htmlAttrs: {
                lang: "en-US",
            },
            meta: [
                { name: "description", content: this.metaDesc,},
                { name: "keywords", content: this.metaKeyword,},
                { name: "author", content: 'trainway'},
                { name: "robots", content: 'index, follow',},

                { name: "twitter:card", content: 'summary_large_image',},
                { name: "twitter:title", content: this.metaTitle,},
                { name: "twitter:description", content: this.metaDesc,},
                { name: "twitter:image", content: this.image,},
                { name: "twitter:site", content: '@trainway',},


                { property: "og:title", content: this.metaTitle,},
                { property: "og:description", content: this.metaDesc,},
                { property: "og:image", content: this.image,},
                { property: "og:url", content: this.siteUrl,},
                { property: "og:type", content: 'website',},
                { property: "og:site_name", content: 'trainway',},
            ],
            link: [{
                rel: "canonical",
                href: this.siteUrl,
            }, ],
        }
    },
    data: () => ({
        metaTitle: undefined,
        metaDesc: undefined,
        metaKeyword: undefined,
        image: undefined,
        siteUrl: undefined,
        content: "",

        pagetitle: null,
        pagesubtitle: null,
        pagecontent: null,

        orderid: null,
        snackbar: false,
        snackbartext: "",

        overlay: true,
        sheet: false,
        drawer: false,

    }),
    methods: {
        getMeta() {
            axios.get(`/api/getMeta/track-order`).then((response) => {

                this.metaTitle = response.data.meta_title;
                this.metaDesc = response.data.meta_discription;
                this.metaKeyword = response.data.meta_keyword;

                this.image = 'https://elastic.trainway.in/images/'+response.data.feature_img;
                this.siteUrl = 'https://www.trainway.in/track-order';
                //
                this.pagecontent = response.data.content;
                this.pagetitle = response.data.title;
                this.pagesubtitle = response.data.sub_title;
            })
        },
        trackorder() {
            if (this.orderid != null) {
                this.$router.push('/track/' + this.orderid);
            } else {
                this.snackbartext = "Please Enter order id";
                this.snackbar = true;
            }
        }
    },
    created() {
        this.getMeta();
    }
}
</script>
<style>

.imagewrap .theme--light.v-image{position: relative; height: 120px;}
.imagewrap .v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}

.contactinfo .v-image.v-responsive.theme--light .v-image__image.v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}
.contactinfo .imagewrap .v-image__image--cover{width: 100%; height: 100%; object-fit: contain;}

.v-navigation-drawer__content{background: #f0ffff;}
#inspire .v-list-item__icon{margin-right: 10px;}

.contactinfo .v-list-item__title{margin-bottom: 8px; color: rgba(0,0,0,.87); text-decoration: none;}
.contactinfo .v-list-item__title i{margin: 0px 6px 6px 0px;}

.bannersearcbox {
  padding: 120px 0;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  margin-bottom: 15px;
}

.bannersearcbox .v-input.v-input--hide-details {
  background-color: #fff;
}

@media (max-width: 767px) {
  .bannersearcbox {
    padding: 0;
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    margin-bottom: 0;
    background: #fff !important;
  }
}

.p-12 {
    color: #444;
    font-size: 12px !important;
}

.p-14 {
    font-size: 14px !important;
}

.step {
    max-width: 50px;
    max-height: 50px;
}

 @media (max-width: 767px) {
        .hidden-mobile {
          display: none;
        }
      }
</style>
